import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Tab } from '@headlessui/react';
import WarehouseList from '../components/warehouse/WarehouseList';
import WarehouseLocationList from '../components/warehouse/WarehouseLocationList';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { BuildingStorefrontIcon, PlusIcon } from '@heroicons/react/24/outline';

const Warehouse: React.FC = () => {
  const { t } = useLanguage();

  const handleCreateWarehouse = () => {
    if ((window as any).triggerCreateWarehouse) {
      (window as any).triggerCreateWarehouse();
    }
  };

  return (
    <div className="space-y-6 pb-20 sm:pb-0">
      <CommonPageHeader
        title={t('warehouse.title')}
        subtitle={t('warehouse.subtitle')}
        icon={BuildingStorefrontIcon}
      >
        <button
          onClick={handleCreateWarehouse}
          className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-lg hover:bg-white/30 transition-colors flex items-center text-sm font-medium"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          {t('warehouse.list.create')}
        </button>
      </CommonPageHeader>
      
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md">
        <Tab.Group>
          <Tab.List className="flex border-b border-gray-200 dark:border-gray-700 w-full">
            <Tab
              className={({ selected }) =>
                `py-3 px-4 sm:px-6 text-sm font-medium outline-none flex-1 sm:flex-none text-center ${
                  selected
                    ? 'text-primary-600 dark:text-primary-400 border-b-2 border-primary-500 dark:border-primary-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }`
              }
            >
              {t('warehouse.tab.warehouses')}
            </Tab>
            <Tab
              className={({ selected }) =>
                `py-3 px-4 sm:px-6 text-sm font-medium outline-none flex-1 sm:flex-none text-center ${
                  selected
                    ? 'text-primary-600 dark:text-primary-400 border-b-2 border-primary-500 dark:border-primary-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }`
              }
            >
              {t('warehouse.tab.locations')}
            </Tab>
          </Tab.List>
          <Tab.Panels className="w-full">
            <Tab.Panel className="w-full">
              <WarehouseList onCreateWarehouse={() => {}} />
            </Tab.Panel>
            <Tab.Panel className="w-full">
              <WarehouseLocationList />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
};

export default Warehouse; 